import React, {ReactNode} from 'react';
import {Modal} from 'antd';
import CloseIconDialog from 'Components/CloseIconDialog';
import {useCSContext} from 'Context/ContentStackContext';

interface IProps {
  children: ReactNode;
  closeDialogMethod: any;
  open: any;
  id?: any;
  isEscapEnable?: any;
}

function DialogWrapper(props: IProps) {
  const {children, closeDialogMethod, open, isEscapEnable} = props;
  const {artifacts} = useCSContext();

  const handleClose = () => {
    closeDialogMethod(false);
  };

  return (
    <Modal
      // Unmount content on close, as the old MUI Dialog did, so each open starts fresh.
      destroyOnHidden
      open={open}
      onCancel={handleClose}
      closable={false}
      // matches the original's disableEscapeKeyDown={isEscapEnable ?? true} — ESC is
      // disabled (keyboard=false) unless isEscapEnable is explicitly passed false.
      keyboard={isEscapEnable === false}
      maskClosable={false}
      footer={null}>
      <CloseIconDialog callback={handleClose} image={artifacts.cross_icon} />
      {children}
    </Modal>
  );
}

export default DialogWrapper;
